const appKey = process.env.GATSBY_APP
if (!appKey) {
  throw new Error("appKey 不能为空")
}

const title = "吉考斯工业 Official Website"
const desc = "由游戏社群平台GCORES机核®孵化并打造的服装、配饰及生活方式品牌。"

const cdnUrl = "https://industries.gcores.com"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/`,
  securityQuery: {
    endpoint: "https://ckglobal.fw-12365.com/ashx/SecurityQueryApi.ashx",
    key: "XSHC27601CA000",
    lang: "en-gb",
  },
  appInfo: {
    name: title,
    description: desc,
    shareTitle: title,
    shareDescription: desc,
  },
}
